<template>
	<div class="fileInfo">
		<div class="logo">
			<img src="../../assets/images/icon/logo.png" alt="">
		</div>
		<div class="steps">
			<img src="../../assets/images/icon/step1.png" alt="">
			<div class="steps_title flex align-center justify-between">
				<div 
					v-for="(item,index) in stepList " :key="index"
					:class="stepActive == index ? 'active' : ''">{{item}}</div>
			</div>
			<div class="first_title">{{stepActive == 0 ? 'Create your Account' :stepActive == 1 ? 'Add a child' : 'We would like to know a bit more about you'}}</div>
		</div>
		<div class="file_detail">
			<step1 @toNext="toNext" @toTerm="toTerm" :userInfo="userInfo" v-if="stepActive == 0"></step1>
			<step2 @toNext="toNext" v-if="stepActive == 1"></step2>
			<step3 @toNext="toNext" v-if="stepActive == 2"></step3>
		</div>
		<div class="bottom_help flex align-center justify-center">
			<div><span>Contact : info@Curiouser-family.com </span> Telephone: +44 (0)7462258770</div>
			<!-- <div class="help">帮助</div> -->
		</div>
		<div class="model" v-if="selectModel" @click="selectModel = false">
			<div class="model_content" @click.stop="">
				<div class="detail" v-html="detail.privacy_policy"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import step1 from '/src/components/fileInfo/step1.vue'
	import step2 from '/src/components/fileInfo/step2.vue'
	import step3 from '/src/components/fileInfo/step3.vue'
	export default{
		components:{
			step1,
			step2,
			step3
		},
		data(){
			return{
				stepActive:0,
				stepList:['Sign up','Add a Child','Complete'],
				userInfo:{},
				selectModel:false,
				detail:{},
				confirmPassword:'',
			}
		},
		created(){
			this.getUser()
		},
		methods:{
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			toNext(data){
				console.log(data)
				if(data.type == 1){
					this.stepActive = 1;
					window.scrollTo(0,0)
				}else if(data.type == 2){
					this.stepActive = 2;
				}else{
					// this.$router.push('/home')
					this.$router.go(-3)
				}
			},
			toTerm(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
						this.selectModel = true;
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.fileInfo{
		width: 100%;
		min-height: 100vh;
		background-color: #F7F2EB;
		padding-top: 110px;
		padding-bottom: 40px;
		.logo{
			width: 557px;
			height: 122px;
			margin: 0 auto;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.steps{
			width: 1200px;
			margin: 80px auto 40px;
			img{
				width: 100%;
				height: 52px;
			}
			.steps_title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				&.active{
					color: #282E30;
				}
			}
			.first_title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				margin-top: 60px;
				text-align: center;
			}
		}
		.file_detail{
			padding-top: 50px;
		}
		.bottom_help{
			margin-top: 160rpx;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			span{
				margin-right: 50px;
			}
			.help{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin-left: 56rpx;
				cursor: pointer;
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
		}
		
	}
</style>